import {ActionButtonsParams, ToggleButtonsParams} from "../types/records-table-toolbar.types";

export const toggleButtons: Array<ToggleButtonsParams> = [
  { action: 'EDIT_MODE', label: 'Режим редактирования' },
  { action: 'HIDE_PROCESSED', key: 'showProcessed', label: 'Показать отработанных' },
  { action: 'SHOW_MISTAKES', key: 'showMistakes', label: 'Показать ошибки' },
  { action: 'SHOW_ALL_TEAMS', key: 'showAllTeams', label: 'Показать другие команды' },
  { action: 'SHOW_REJECTED', key: 'showRejected', label: 'Показать отказы' }
]

export const actionButtons: Array<ActionButtonsParams> = [
  { action: 'UPLOAD_PRODUCT_PACKAGES_EXCEL', tooltip: 'Загрузить упаковки', icon: 'file_upload_outlined' },
  { action: 'DOWNLOAD_PRODUCT_PACKAGES_EXCEL', tooltip: 'Скачать упаковки', icon: 'file_download' },
  { action: 'LINE_CHART', tooltip: 'Линейный график', icon: 'ssid_chart' },
  { action: 'SETTINGS_TABLE', tooltip: 'Показать/Скрыть колонки', icon: 'settings' }
]

export const toggleGroupActionButtons: Array<ActionButtonsParams> = [
  { action: 'EXPAND_GROUP', tooltip: 'Развернуть все группы', icon: 'unfold_more' },
  { action: 'COLLAPSE_GROUP', tooltip: 'Свернуть все группы', icon: 'unfold_less' }
]
